import { render, staticRenderFns } from "./ProductOtherConfig.vue?vue&type=template&id=0a4c4d4e&scoped=true&"
import script from "./ProductOtherConfig.vue?vue&type=script&lang=js&"
export * from "./ProductOtherConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4c4d4e",
  null
  
)

export default component.exports